import { use } from 'react';

import { CogniteClientContext } from '#contexts/CogniteClientContext';

export const useCogniteClient = () => use(CogniteClientContext);
